<div class="flex flex-column md:flex-row gap-5 w-full container_width">
  <div class="flex gap-4 flex-column col-12 md:col-8">
    <div class="flex gap-3 flex-column md:flex-row align-items-center w-full">
      <p-avatar [image]="user?.profileImageUrl ||'assets/images/default-profile.png'" styleClass="mr-2"
        size="xlarge" shape="circle" />

      <div class="flex flex-column gap-2 md:gap-1">
        <h1 class="font-semibold text-2xl sm:text-4xl line-height-1 text-center md:text-left">
          Hi{{(user?.firstName || user?.lastName) ? ' ' + (user?.firstName ?? '') + (user?.firstName && user?.lastName ? ' ' : '') + (user?.lastName ?? '') : ''}}, I'm Gradie
        </h1>
        <b class="font-normal text-sm sm:text-base text-center md:text-left text-bluegray-700">How can I help? Ask about
          school recommendations, writing essays, paying for college, and more.</b>
      </div>
    </div>
    <div class="flex-1 flex flex-column gap-3 md:gap-4 ">
      <div class="w-full">
        <p-iconField iconPosition="right">
          <p-inputIcon styleClass="pi pi-send" />
          <input
            type="text"
            pInputText
            placeholder="Ask Me Anything"
            class="w-full ask-me"
            (click)="chatDialog.showDialog()"
            readonly />
        </p-iconField>
      </div>
      <!-- <div class="flex align-items-center flex-wrap gap-1 justify-content-start md:gap-2">
        <div class="flex align-items-center">
          <p-checkbox [(ngModel)]="pizza" label="Suggest colleges" name="pizza" value="Suggest colleges"
            styleClass="filterChk" labelStyleClass="labelStyle" />
        </div>
        <div class="flex align-items-center">
          <p-checkbox [(ngModel)]="pizza" label="Brainstorm essays" name="pizza" value="Brainstorm essays"
            styleClass="filterChk" labelStyleClass="labelStyle" />
        </div>
        <div class="flex align-items-center">
          <p-checkbox [(ngModel)]="pizza" label="Paying for college" name="pizza" value="Paying for college"
            styleClass="filterChk" labelStyleClass="labelStyle" />
        </div>
        <div class="flex align-items-center">
          <p-checkbox [(ngModel)]="pizza" label="Recommend programs" name="pizza" value="Recommend programs"
            styleClass="filterChk" labelStyleClass="labelStyle" />
        </div>
      </div> -->
    </div>
  </div>
  <div
    class="flex-auto flex flex-column align-items-center justify-content-center gap-3 p-4 border-1 border-gray-300 border-round-xl">
    <ngx-gauge [markers]="markers" [size]="225" foregroundColor="#000086" backgroundColor="#CED12A" [duration]="2500"
      [type]="gaugeType" [thick]="20" [value]="gaugeValue" [label]="gaugeLabel" [append]="gaugeAppendText">
    </ngx-gauge>
    <div class="flex align-items-center justify-content-center">
      <p-button (onClick)="completeProfile()" label="Application Form" styleClass="complete_profile" />
    </div>
  </div>
</div>

<!-- Chat Dialog Component -->
<app-chat-dialog #chatDialog></app-chat-dialog>
